import {connect, useSelector} from "react-redux";
import React, {useEffect, useState} from "react";
import dayjs from "dayjs";
import * as api from "../../../api/api";
import * as Global from "../../common/Global";
import { StandardListPage } from "../../../components/StandardListPage";
import { MANAGE_TYPE } from "../../../config/menuConfig";

const SPLIT_GAME = MANAGE_TYPE === '2';
const TREE_GRID = SPLIT_GAME
    ? "grid-cols-[minmax(140px,1.4fr)_minmax(140px,1.4fr)_repeat(11,minmax(96px,1fr))]"
    : "grid-cols-[minmax(140px,1.4fr)_minmax(140px,1.4fr)_repeat(8,minmax(90px,1fr))]";

const formatProfit = (bet, win) => {
    const betting = Number(bet || 0);
    const winning = Number(win || 0);
    const amount = betting - winning;
    const rate = betting === 0 ? 0 : (amount / betting) * 100;
    const color = amount > 0 ? "text-green-600" : amount < 0 ? "text-red-600" : "text-gray-500";
    return { text: `${Global.currencyFormatter({ value: amount })}(${rate.toFixed(1)}%)`, color };
};

/* depth별 배경색 (점점 진하게) - Tailwind 인식을 위해 전체 클래스명 나열 */
const DEPTH_BG = [
    "bg-white hover:bg-gray-50",
    "bg-gray-50 hover:bg-gray-100",
    "bg-gray-100 hover:bg-gray-200",
    "bg-gray-200 hover:bg-gray-300",
    "bg-gray-300 hover:bg-gray-400",
    "bg-gray-400 hover:bg-gray-500",
];

const TreeItem = ({ item, level = 0, onUserClick }) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const hasChildren = item.children && item.children.length > 0;
    const bgColor = DEPTH_BG[Math.min(level, DEPTH_BG.length - 1)];

    return (
        <div className="border-b border-gray-200 last:border-b-0">
            <div className={`flex items-center text-xs transition-colors ${bgColor}`}>
                <div className={`flex-1 grid ${TREE_GRID} gap-0 min-w-[1100px]`}>
                    <div className="px-2 py-2 border-r border-gray-200 flex items-center" style={{ marginLeft: `${level * 16}px` }}>
                        <span className="text-gray-700">{item.userPath}</span>
                    </div>
                    <div className="px-2 py-2 border-r border-gray-200 flex items-center" style={{ marginLeft: `${level * 16}px` }}>
                        <span
                            className="cursor-pointer text-blue-600 hover:text-blue-800 font-medium"
                            onClick={() => onUserClick(item)}
                        >
                            {item.userId}
                        </span>
                        {hasChildren && (
                            <button
                                className="ml-2 w-5 h-5 flex items-center justify-center bg-gray-200 text-gray-700 hover:bg-gray-300"
                                onClick={() => setIsExpanded(!isExpanded)}
                            >
                                {isExpanded ? '−' : '+'}
                            </button>
                        )}
                    </div>
                    <div className="px-2 py-2 border-r border-gray-200 text-right text-green-600 flex items-center justify-end">
                        {Global.currencyFormatter({ value: item.depositAmount })}
                    </div>
                    <div className="px-2 py-2 border-r border-gray-200 text-right text-red-600 flex items-center justify-end">
                        {Global.currencyFormatter({ value: item.withdrawAmount })}
                    </div>
                    <div className={`px-2 py-2 border-r border-gray-200 text-right flex items-center justify-end ${(item.depositAmount - item.withdrawAmount) >= 0 ? 'text-green-600' : 'text-red-600'}`}>
                        {Global.currencyFormatter({ value: item.depositAmount - item.withdrawAmount })}
                    </div>
                    <div className="px-2 py-2 border-r border-gray-200 text-right text-gray-700 flex items-center justify-end">
                        {Global.currencyFormatter({ value: item.bettingCount })}
                    </div>
                    {SPLIT_GAME ? (
                        <>
                            <div className="px-2 py-2 border-r border-gray-200 text-right text-gray-700 flex items-center justify-end">
                                {Global.currencyFormatter({ value: item.casinoBettingAmount })}
                            </div>
                            <div className="px-2 py-2 border-r border-gray-200 text-right text-gray-700 flex items-center justify-end">
                                {Global.currencyFormatter({ value: item.casinoWinningAmount })}
                            </div>
                            <div className={`px-2 py-2 border-r border-gray-200 text-right flex items-center justify-end ${formatProfit(item.casinoBettingAmount, item.casinoWinningAmount).color}`}>
                                {formatProfit(item.casinoBettingAmount, item.casinoWinningAmount).text}
                            </div>
                            <div className="px-2 py-2 border-r border-gray-200 text-right text-gray-700 flex items-center justify-end">
                                {Global.currencyFormatter({ value: item.slotBettingAmount })}
                            </div>
                            <div className="px-2 py-2 border-r border-gray-200 text-right text-gray-700 flex items-center justify-end">
                                {Global.currencyFormatter({ value: item.slotWinningAmount })}
                            </div>
                            <div className={`px-2 py-2 border-r border-gray-200 text-right flex items-center justify-end ${formatProfit(item.slotBettingAmount, item.slotWinningAmount).color}`}>
                                {formatProfit(item.slotBettingAmount, item.slotWinningAmount).text}
                            </div>
                        </>
                    ) : (
                        <>
                            <div className="px-2 py-2 border-r border-gray-200 text-right text-gray-700 flex items-center justify-end">
                                {Global.currencyFormatter({ value: item.bettingAmount })}
                            </div>
                            <div className="px-2 py-2 border-r border-gray-200 text-right text-gray-700 flex items-center justify-end">
                                {Global.currencyFormatter({ value: item.bettingWinningAmount })}
                            </div>
                            <div className={`px-2 py-2 border-r border-gray-200 text-right flex items-center justify-end ${formatProfit(item.bettingAmount, item.bettingWinningAmount).color}`}>
                                {formatProfit(item.bettingAmount, item.bettingWinningAmount).text}
                            </div>
                        </>
                    )}
                    <div className="px-2 py-2 text-right text-gray-700 flex items-center justify-end">
                        {Global.currencyFormatter({ value: item.feeAmount })}
                    </div>
                </div>
            </div>
            {hasChildren && isExpanded && (
                <div>
                    {item.children.map((child, index) => (
                        <TreeItem key={index} item={child} level={level + 1} onUserClick={onUserClick} />
                    ))}
                </div>
            )}
        </div>
    );
};

const UserTreeView = (props) => {
    const {user} = useSelector((props) => props.account);
    const [loading, setLoading] = useState(false)
    const [searchForm, setSearchForm] = useState({
        startTime: dayjs(),
        endTime: dayjs()
    })
    const [settleData, setSettleData] = useState([])

    useEffect(() => {
        search()
    }, [])

    const handleUserClick = (data) => {
        const params = "userId=" + data.userId + "&procUserId=" + user.userId
        const popup = window.open('/#/user/detail?' + params, "_user-detail", "width=1500, height=800");
        if (popup) popup.focus();
    }

    const buildTree = (data) => {
        const tree = [];
        const map = {};

        // 먼저 모든 항목을 map에 저장
        data.forEach(item => {
            map[item.userId] = { ...item, children: [] };
        });

        // 트리 구조 구성
        data.forEach(item => {
            const pathParts = item.userPath.split(' > ');
            if (pathParts.length > 1) {
                const parentPath = pathParts.slice(0, -1).join(' > ');
                const parentItem = data.find(d => d.userPath === parentPath);
                if (parentItem && map[parentItem.userId]) {
                    map[parentItem.userId].children.push(map[item.userId]);
                } else {
                    tree.push(map[item.userId]);
                }
            } else {
                tree.push(map[item.userId]);
            }
        });

        return tree;
    };

    const search = () => {
        const params = {
            companyCode: user.companyCode,
            rootUserId: user.rootUserId,
            fromDate: '20250101',
            toDate: searchForm.endTime.format("YYYYMMDD")
        }

        setLoading(true)
        api.getUserStatistics(params).then(result => {
            const {data, status, statusText} = result
            if (status === 200) {
                const treeData = buildTree(data);
                setSettleData(treeData);
            }
        })
            .catch(ex => {
                window.alert(ex.message)
            })
            .finally(() => {
                setLoading(false)
            })
    }

    return (
        <StandardListPage
            title="회원 트리뷰"
            loading={loading}
            actionButtons={
                <button className="h-7 px-3 bg-gray-600 text-white text-xs font-medium" onClick={search}>조회</button>
            }
        >
            <div className="border border-gray-200 overflow-x-auto">
                <div className={`grid ${TREE_GRID} gap-0 bg-gray-800 min-h-8 min-w-[1100px] text-white text-xs font-semibold`}>
                    <div className="border-r border-gray-600 px-2 flex items-center">영업진</div>
                    <div className="border-r border-gray-600 px-2 flex items-center">회원</div>
                    <div className="text-right border-r border-gray-600 px-2 flex items-center justify-end">입금액</div>
                    <div className="text-right border-r border-gray-600 px-2 flex items-center justify-end">출금액</div>
                    <div className="text-right border-r border-gray-600 px-2 flex items-center justify-end">수익금</div>
                    <div className="text-right border-r border-gray-600 px-2 flex items-center justify-end">베팅수</div>
                    {SPLIT_GAME ? (
                        <>
                            <div className="text-right border-r border-gray-600 px-2 flex items-center justify-end">카지노 배팅</div>
                            <div className="text-right border-r border-gray-600 px-2 flex items-center justify-end">카지노 당첨</div>
                            <div className="text-right border-r border-gray-600 px-2 flex items-center justify-end">카지노 손익</div>
                            <div className="text-right border-r border-gray-600 px-2 flex items-center justify-end">슬롯 배팅</div>
                            <div className="text-right border-r border-gray-600 px-2 flex items-center justify-end">슬롯 당첨</div>
                            <div className="text-right border-r border-gray-600 px-2 flex items-center justify-end">슬롯 손익</div>
                        </>
                    ) : (
                        <>
                            <div className="text-right border-r border-gray-600 px-2 flex items-center justify-end">베팅금</div>
                            <div className="text-right border-r border-gray-600 px-2 flex items-center justify-end">당첨금</div>
                            <div className="text-right px-2 flex items-center justify-end border-r border-gray-600">손익</div>
                        </>
                    )}
                    <div className="text-right px-2 flex items-center justify-end">수수료</div>
                </div>
                <div className="max-h-[calc(100vh-250px)] overflow-y-auto bg-white">
                    {settleData.map((item, index) => (
                        <TreeItem key={index} item={item} onUserClick={handleUserClick} />
                    ))}
                </div>
            </div>
        </StandardListPage>
    )
}

const mapStateToProps = (state) => {
    const {account, store} = state;
    return {
        account, store
    }
}

export default connect(mapStateToProps, null)(UserTreeView);